import React from 'react';
import { CenteredMessage } from '../../../components/layout/CenteredMessage';

export const PlayerStartingView: React.FC = () => {
    return <CenteredMessage>The game is starting. Good luck!</CenteredMessage>;
};
